import { create } from 'zustand'

interface ClassCreationStore {
  classData: any
  setClassData: (data: any) => void
  agreements: string[]
  setAgreements: (agreements: string[]) => void
  itemsToBring: string[]
  setItemsToBring: (items: string[]) => void
  selectedFaqIds: string[]
  setSelectedFaqIds: (faqs: string[]) => void
  selectedRequiredDocumentIds: string[]
  setSelectedRequiredDocumentIds: (docs: string[]) => void
  riskLevel: 'low' | 'medium' | 'high'
  setRiskLevel: (level: 'low' | 'medium' | 'high') => void
  coverPhotoIds: string[]
  setCoverPhotoIds: (photos: string[]) => void
  description: string
  setDescription: (desc: string) => void
  emailTemplates: any[]
  setEmailTemplates: (templates: any[]) => void
}

const classCreationStore = (set: any) => ({
  classData: null,
  setClassData: (data: any) => set(() => ({ classData: data })),
  agreements: [],
  setAgreements: (agreements: string[]) => set(() => ({ agreements })),
  itemsToBring: [],
  setItemsToBring: (items: string[]) => set(() => ({ itemsToBring: items })),
  selectedFaqIds: [],
  setSelectedFaqIds: (faqs: string[]) => set(() => ({ selectedFaqIds: faqs })),
  selectedRequiredDocumentIds: [],
  setSelectedRequiredDocumentIds: (docs: string[]) => set(() => ({ selectedRequiredDocumentIds: docs })),
  riskLevel: 'low' as const,
  setRiskLevel: (level: 'low' | 'medium' | 'high') => set(() => ({ riskLevel: level })),
  coverPhotoIds: [],
  setCoverPhotoIds: (photos: string[]) => set(() => ({ coverPhotoIds: photos })),
  description: '',
  setDescription: (desc: string) => set(() => ({ description: desc })),
  emailTemplates: [],
  setEmailTemplates: (templates: any[]) => set(() => ({ emailTemplates: templates })),
})

export const creationClassStore = create(classCreationStore)
